<template>
    <b-form-group>
        <v-select
            id="common-select-group"
            class="common-select"
            ref="common-select-group"
            v-model="groupModel"
            :options="groupOptions"
            :placeholder="groupPlaceholder"
            :selectable="groupSelectable"
            :clearable="clearable"
            label="groupNamePath"
            @option:selected="handleSelectGroup"
        ></v-select>
    </b-form-group>
</template>
<script>
import bus from '@/libs/bus'
import vSelect from 'vue-select'
import useSelectProjectAndGroup from '@/composables/useSelectProjectAndGroup'
import { watch, onUnmounted } from '@vue/composition-api'
export default {
    components: {
        vSelect
    },
    props: ['clearable', 'storeKey'],
    setup (props, context) {
        const {
            groupModel,
            selectedGroup,
            groupOptions,
            groupPlaceholder,
            groupSelectable,
            handleSelectGroup,
            handleClearGroup
        } = useSelectProjectAndGroup()

        watch(selectedGroup, (value, oldValue) => {
            groupModel.value = value?.groupIdx ? value : null
        })
        bus.$on('vSelect:Deselect:common-select-group', handleClearGroup)
        onUnmounted(() => {
            bus.$off('vSelect:Deselect:common-select-group', handleClearGroup)
        })
        return {
            groupModel,
            groupOptions,
            groupPlaceholder,
            groupSelectable,
            handleSelectGroup
        }
    }
}
</script>
